<template>
    <div>
        <q-input-number
            outlined
            v-model="originAmount"
            type="number"
            input-class="input-bold ltr"
            color="primary"
            :label="$t('calculator.you_send')"
            :error="error.has('origin_amount')"
            :error-message="error.get('origin_amount')"
            :rules="[val => (val && val >= minTransferAmount && val <= maxTransferAmount || $t('calculator.errors.sending_amount_range', { min: minTransferAmount.toString().commaSeparate(), max: maxTransferAmount.toString().commaSeparate(), currency: originCurrency.symbol}))]"
            v-if="originCurrency"
        >
            <template v-slot:append>
                <q-btn-dropdown
                    v-model="displayOrgCurrencies"
                    :label="originCurrency.symbol"
                    :icon="originCurrency.country"
                    flat
                    dense
                    dir="ltr"
                >
                    <q-list>
                        <q-item
                            clickable
                            v-close-popup
                            v-for="org_currency in origin_currencies"
                            :key="org_currency.acronym"
                            @click="changeOriginCurrency(org_currency)"
                        >
                            <q-item-section avatar>
                                <q-icon :name="org_currency.country" size="36px" />
                            </q-item-section>
                            <q-item-section>
                                <q-item-label>{{ org_currency.currency }}</q-item-label>
                            </q-item-section>
                        </q-item>
                    </q-list>
                </q-btn-dropdown>
            </template>
        </q-input-number>
        <q-skeleton type="QInput" v-else/>
    </div>
</template>

<script>

import { mapGetters } from 'vuex'
import QInputNumber from "src/components/QInputNumber.vue"

export default {
    name: "OriginInputBox",
    components: { QInputNumber },
    model: {
        prop: 'amount',
        event: 'change'
    },
    props: {
        amount: {
            type: [Number, String],
            required: true
        },
        minTransferAmount: {
            type: Number,
            default: 0
        },
        maxTransferAmount: {
            type: Number,
            default: 0
        },
        error: {
            type: Object,
            default: () => ({})
        }
    },
    computed: {
        ...mapGetters(['exchange_rates']),
        originAmount: {
            get: function() {
                return this.amount
            },
            set: function(value) {
                this.$emit('change', value)
            }
        },
        origin_currencies() {
            let currencies = []
            this.exchange_rates.forEach((item) => {
                if (!currencies.find(value => value.acronym === item.from.acronym) && item.active) {
                    currencies.push(item.from)
                }
            })
            return currencies
        },
    },
    data() {
        return {
            originCurrency: null,
            displayOrgCurrencies: false
        }
    },
    methods: {
        findDefaultOriginCurrency() {
            if (!this.exchange_rates.length) {
                return null
            }

            let last_from_currency = this.$q.cookies.has('last_from_currency')
                ? this.$q.cookies.get('last_from_currency')
                : this.origin_currencies[0].acronym

            if (!this.origin_currencies.some(rate => rate.acronym === last_from_currency)) {
                last_from_currency = this.origin_currencies[0].acronym
            }

            if (this.$route.params.currency) {
                last_from_currency = this.exchange_rates.filter(rate => rate.to.acronym === this.$route.params.currency)[0].from.acronym
            }

            return this.origin_currencies.find(item => item.acronym === last_from_currency)
        },
        setOriginCurrency() {
            this.originCurrency = this.findDefaultOriginCurrency()
            this.$emit('originChanged', { origin_dest: 'origin', currency: this.originCurrency ? this.originCurrency.acronym : '' })
        },
        changeOriginCurrency(currency) {
            if (this.originCurrency === currency) {
                return
            }
            this.originCurrency = currency
            this.$emit('originChanged', { origin_dest: 'origin', currency: currency.acronym })
        }
    },
    mounted() {
        this.setOriginCurrency()
    },
    watch: {
        exchange_rates(val, old) {
            if (!old.length) {
                this.setOriginCurrency()
            }
        }
    }
}
</script>
